import React, { useState, useCallback } from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import ModernChatContainer from '../organisms/chat/ModernChatContainer';

interface ModernChatPageProps {
  groupId?: string;
  groupName?: string;
  embedded?: boolean; // Flag for embedded usage (no header, no container padding)
}

const ModernChatPage: React.FC<ModernChatPageProps> = ({
  groupId = 'demo-group-123',
  groupName = 'Demo Chat Group',
  embedded = false,
}) => {
  const [chatTitle, setChatTitle] = useState<string>(groupName);

  const handleHeaderUpdate = useCallback((title: string) => {
    setChatTitle(title);
  }, []);

  // If embedded, render just the chat container without page wrapper
  if (embedded) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative", // Ensure positioning context
          isolation: "isolate", // Isolate from parent stacking context
          contain: "layout style", // CSS containment
        }}
      >
        <ModernChatContainer
          groupId={groupId}
          groupName={groupName}
          onHeaderUpdate={handleHeaderUpdate}
        />
      </Box>
    );
  }

  // Full page mode with header
  return (
    <Container 
      maxWidth={false} 
      sx={{ 
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        backgroundColor: '#f5f5f5',
        overflow: 'hidden', // Prevent page scrolling
      }}
    >
      {/* Page Header */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: '#1a2d66' }}>
          {chatTitle}
        </Typography>
        <Typography variant="body2" sx={{ color: '#6B7280' }}>
          Modern Chat Interface - Desktop Version
        </Typography>
      </Box>

      {/* Chat Container */}
      <Paper
        elevation={2}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderRadius: 2,
          backgroundColor: '#ffffff',
        }}
      >
        <ModernChatContainer
          groupId={groupId}
          groupName={groupName}
          onHeaderUpdate={handleHeaderUpdate}
        />
      </Paper>
    </Container>
  );
};

export default ModernChatPage;
